var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAvidxCoinsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 11.5C22.5 17.299 17.799 22 12 22C6.20101 22 1.5 17.299 1.5 11.5C1.5 5.70101 6.20101 1 12 1C17.799 1 22.5 5.70101 22.5 11.5ZM23.5 11.5C23.5 17.8513 18.3513 23 12 23C5.64873 23 0.5 17.8513 0.5 11.5C0.5 5.14873 5.64873 0 12 0C18.3513 0 23.5 5.14873 23.5 11.5ZM21.1998 11.5C21.1998 16.581 17.0808 20.7 11.9998 20.7C6.91879 20.7 2.7998 16.581 2.7998 11.5C2.7998 6.41898 6.91879 2.3 11.9998 2.3C17.0808 2.3 21.1998 6.41898 21.1998 11.5ZM14.316 12.6482L13.532 8.6882C13.5 8.50686 13.4627 8.2962 13.42 8.0562C13.3773 7.81619 13.3347 7.55486 13.292 7.27219C13.1853 7.55486 13.0813 7.81619 12.98 8.0562C12.8787 8.2962 12.788 8.50953 12.708 8.69619L10.956 12.6482H14.316ZM17.332 17.0002H15.724C15.5427 17.0002 15.4013 16.9575 15.3 16.8722C15.204 16.7815 15.1347 16.6669 15.092 16.5282L14.612 14.1122H10.3L9.228 16.5282C9.16933 16.6509 9.07333 16.7602 8.94 16.8562C8.812 16.9522 8.66267 17.0002 8.492 17.0002H6.86L12.452 5.43219H14.572L17.332 17.0002Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvidxCoinsActive);
export default __webpack_public_path__ + "static/media/icon-avidx-coins-active.07dcc4ea0315c25a626ce3b1dafb453c.svg";
export { ForwardRef as ReactComponent };